import { DashboardLayout } from "../components/DashboardLayout";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Download, FileText } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const policiesDocs = [
  {
    title: "AI Policies Interview Sheet",
    description: "Structured interview template for AI policies assessment",
    link: "https://res.cloudinary.com/dcfotquxt/image/upload/v1772945998/Ai-AssEss/AI_Policies_Questionaire_V_1_02262026_m0wiia.pdf",
  },
];

const readinessDocs = [
  {
    title: "AI Readiness Interview Sheet",
    description: "Comprehensive interview template for AI readiness evaluation",
    link: "https://res.cloudinary.com/dcfotquxt/raw/upload/v1758030172/Ai-AssEss/GoWest_Employee_AI_Readiness_Interview_Questions_x0oy8c.docx",
  },
];

function DocCard({ doc }) {
  return (
    <Card className="shadow-[var(--card-shadow)] flex flex-col justify-between">
      <CardContent className="pt-5 pb-4 flex flex-col h-full">
        <div className="flex items-start gap-3 mb-4">
          <div className="rounded-lg bg-primary/20 p-2 shrink-0">
            <FileText className="h-5 w-5 text-accent" />
          </div>
          <div>
            <p className="font-semibold text-sm font-display">{doc.title}</p>
            <p className="text-xs text-muted-foreground mt-0.5">
              {doc.description}
            </p>
          </div>
        </div>
        <Button
          variant="outline"
          size="sm"
          className="gap-1.5 w-full mt-auto"
          asChild={!!doc.link}
          disabled={!doc.link}
        >
          {doc.link ? (
            <a
              download
              onClick={() => {
                const rawUrl = doc.link;
                const downloadUrl = rawUrl.replace(
                  "/upload/",
                  "/upload/fl_attachment/",
                );
                const a = document.createElement("a");
                a.href = downloadUrl;
                a.rel = "noopener";
                a.download = doc.title;
                a.target = "_blank";
                document.body.appendChild(a);
                a.click();
                a.remove();
              }}
              className="cursor-pointer"
            >
              <Download className="h-3.5 w-3.5" />
              Download
            </a>
          ) : (
            <>
              <Download className="h-3.5 w-3.5" />
              Download
            </>
          )}
        </Button>
      </CardContent>
    </Card>
  );
}

const DocumentsNewV1 = () => {
  const { t } = useLanguage();

  return (
    <DashboardLayout>
      <div className="max-w-6xl mx-auto space-y-8">
        <div>
          <h1 className="text-3xl font-bold font-display tracking-tight text-foreground">
            {t("Documents")}
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            {t("Download interview sheets and reference materials")}
          </p>
        </div>

        {/* AI Policies & Guidelines */}
        <section>
          <h2 className="text-lg font-semibold font-display mb-3">
            {t("AI Policies & Guidelines")}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {policiesDocs.map((doc) => (
              <DocCard key={doc.title} doc={doc} />
            ))}
          </div>
        </section>

        {/* AI Readiness Assessment */}
        <section>
          <h2 className="text-lg font-semibold font-display mb-3">
            {t("AI Readiness Assessment")}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {readinessDocs.map((doc) => (
              <DocCard key={doc.title} doc={doc} />
            ))}
          </div>
        </section>

        {/* Footer */}
        <footer className="text-center text-xs text-muted-foreground py-4 border-t">
          © {new Date().getFullYear()} GoWest.ai — All Rights Reserved ·{" "}
          <a
            href="mailto:support@bizvantage.ai"
            className="text-accent hover:underline"
          >
            support@bizvantage.ai
          </a>
        </footer>
      </div>
    </DashboardLayout>
  );
};

export default DocumentsNewV1;
